import type { OktaAuthOptions } from '@okta/okta-auth-js';

import { env } from 'env';

const oktaUrl = env.REACT_APP_OKTA_URL || 'https://verify.marketviewedu.dev';

const oktaConfig: OktaAuthOptions & { url?: string } = {
  url: oktaUrl,
  issuer: `${oktaUrl}/oauth2/default`,
  redirectUri: `${window.location.origin}/implicit/callback`,
  clientId: env.REACT_APP_OKTA_CLIENT_ID || '0oaoudqosn0Jxya4Z0h7',
  pkce: true,
  tokenManager: {
    storage: 'localStorage',
    expireEarlySeconds: 60,
  },
  services: {
    autoRenew: true,
    autoRemove: true,
  },
};

export default oktaConfig;
